import api from "@/lib/api";

export const getInvoiceSettings = () => api.get("/cc/invoices/settings").then((r) => r.data);
export const saveInvoiceSettings = (body) => api.post("/cc/invoices/settings", body).then((r) => r.data);
export const issueInvoice = (source, id, force = false) => api.post("/cc/invoices/issue", { source, id, force }).then((r) => r.data);
export const sweepInvoices = (since_days, dry_run = false) => api.post("/cc/invoices/sweep", { since_days, dry_run }).then((r) => r.data);
export const creditNote = (id, reason) => api.post(`/cc/invoices/${encodeURIComponent(id)}/credit-note`, { reason }).then((r) => r.data);

// Opens (or downloads) a PDF from the backend with the staff token.
export async function openPdf(path, { download = false, filename = "brugo-invoice.pdf" } = {}) {
  const win = download ? null : window.open("", "_blank");
  try {
    const r = await api.get(path, { responseType: "blob", params: download ? { download: true } : {} });
    const url = URL.createObjectURL(r.data);
    if (download) { const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); }
    else if (win) win.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    let msg = e?.message;
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* not JSON */ }
    throw new Error(msg || "Couldn't open the PDF");
  }
}
export const invoicePdf = (inv, download = false) => openPdf(`/cc/invoices/${encodeURIComponent(inv.id)}/pdf`, { download, filename: `brugo-${String(inv.number || inv.id).replace(/\//g, "-")}.pdf` });

export const DOC_LABEL = { tax_invoice: "Tax invoice", receipt: "Receipt", credit_note: "Credit note" };
export const PURPOSES = [
  ["materials", "Materials orders"], ["promise", "Brugo Promise fee"], ["milestone", "Milestone payments"],
  ["start_project", "Start-a-project fee"], ["wallet_topup", "Wallet top-ups"],
];
export const createManualInvoice = (body) => api.post("/cc/invoices/manual", body).then((r) => r.data);
export const moveSeries = (doc_type, next) => api.post("/cc/invoices/series/next", { doc_type, next }).then((r) => r.data);

// Same as backend/invoices.py format_number — live preview of a number series.
export const FY_STYLES = [["yy-yy", "26-27"], ["yyyy-yy", "2026-27"], ["yyyyyy", "202627"], ["yyyy", "2026"], ["none", "No year"]];
export function currentFy(d = new Date()) {
  const ist = new Date(d.getTime() + 330 * 60000);
  const y = ist.getUTCMonth() >= 3 ? ist.getUTCFullYear() : ist.getUTCFullYear() - 1;
  return `${String(y % 100).padStart(2, "0")}-${String((y + 1) % 100).padStart(2, "0")}`;
}
export function formatNumber(cfg, fy, n) {
  const [a, b] = fy.split("-");
  const year = { "yy-yy": fy, "yyyy-yy": `20${a}-${b}`, yyyyyy: `20${a}${b}`, yyyy: `20${a}`, none: "" }[cfg.fy || "yy-yy"] ?? fy;
  const digits = Math.max(1, Math.min(8, Number(cfg.digits) || 5));
  const sep = ["/", "-", ""].includes(cfg.sep) ? cfg.sep : "/";
  return [String(cfg.prefix || "").trim(), year, String(Math.trunc(n)).padStart(digits, "0")].filter(Boolean).join(sep);
}
export function seriesProblems(cfg) {
  const p = [];
  const pre = String(cfg.prefix || "");
  if (!pre || pre.length > 10 || !/^[A-Za-z0-9/-]+$/.test(pre)) p.push("Prefix: 1–10 letters / digits");
  if (cfg.reset === "yearly" && cfg.fy === "none") p.push("Restarting every April needs the year in the number");
  const longest = formatNumber(cfg, "26-27", 10 ** Math.max(1, Math.min(8, Number(cfg.digits) || 5)) - 1);
  if (!p.length && longest.length > 16) p.push(`“${longest}” is ${longest.length} characters; the limit is 16`);
  return p;
}
